// Alpha levels used by the desktop shell. Original CSS values remain fallbacks.
export const desktopThemeAlphas = {
  "heading": [
    0.05,
    0.08,
    0.09,
    0.11,
    0.12,
    0.14,
    0.16,
    0.18,
    0.2,
    0.22,
    0.24,
    0.26,
    0.28,
    0.3,
    0.32,
    0.34,
    0.35,
    0.36,
    0.4,
    0.42,
    0.44,
    0.45,
    0.46,
    0.5,
    0.6,
    0.62,
    0.68,
    0.72,
    0.9
  ],
  "page-dark": [
    0,
    0.06,
    0.12,
    0.14,
    0.16,
    0.18,
    0.2,
    0.22,
    0.24,
    0.28,
    0.3,
    0.32,
    0.34,
    0.35,
    0.4,
    0.42,
    0.44,
    0.46,
    0.48,
    0.5,
    0.52,
    0.56,
    0.58,
    0.6,
    0.62,
    0.66,
    0.68,
    0.72,
    0.74,
    0.76,
    0.78,
    0.8,
    0.82,
    0.84,
    0.85,
    0.86,
    0.88,
    0.9,
    0.92,
    0.94,
    0.95,
    0.96,
    0.97,
    0.98,
    0.99
  ],
  "text": [
    0,
    0.02,
    0.025,
    0.03,
    0.04,
    0.05,
    0.06,
    0.07,
    0.08,
    0.1,
    0.12,
    0.14,
    0.16,
    0.18,
    0.2,
    0.24,
    0.42,
    0.54,
    0.58,
    0.62,
    0.68,
    0.7,
    0.72,
    0.74,
    0.78,
    0.8,
    0.82,
    0.85,
    0.86,
    0.88,
    0.9,
    0.92,
    0.94,
    0.96,
    0.97
  ],
  "card-dark": [
    0.34,
    0.42,
    0.46,
    0.48,
    0.5,
    0.52,
    0.54,
    0.56,
    0.58,
    0.6,
    0.62,
    0.64,
    0.66,
    0.68,
    0.7,
    0.72,
    0.74,
    0.76,
    0.78,
    0.8,
    0.82,
    0.84,
    0.86,
    0.88,
    0.9,
    0.92,
    0.94,
    0.96,
    0.98
  ],
  "accent": [
    0.06,
    0.1,
    0.12,
    0.14,
    0.18,
    0.2,
    0.22,
    0.3,
    0.32,
    0.35,
    0.36,
    0.42,
    0.46,
    0.52,
    0.54,
    0.55,
    0.6,
    0.7,
    0.72,
    0.84,
    0.86,
    0.88,
    0.9,
    0.92,
    0.94,
    0.95,
    0.96
  ],
  "pale": [
    0.2
  ],
  "secondary": [
    0.34
  ],
  "ink": [
    0.16,
    0.18,
    0.2,
    0.26,
    0.28,
    0.3,
    0.32,
    0.34,
    0.38,
    0.4,
    0.42,
    0.44,
    0.46,
    0.48,
    0.52,
    0.58,
    0.72,
    0.74,
    0.84,
    0.86,
    0.9,
    0.92,
    0.96
  ],
  "elevated-dark": [
    0.8,
    0.96
  ]
};
